import React from 'react'

import { shape, number, string } from 'prop-types'

import i18n from 'Pods/Shared/I18n'

import GeometryItem from './GeometryItem'

function GeometryDetailsSection({ geometryDetails, locale = 'en' }) {

  const volume = geometryDetails.volume.toLocaleString(locale)
  const volumeUnit = i18n.t('itemPage.geometryDetails.volumeUnit', { ns: 'rails', lng: locale })
  const volumeTooltipContent = i18n.t('itemPage.geometryDetails.volumeTooltipContent', { ns: 'rails', lng: locale })
  const boundingBoxTooltipContent =
    i18n.t('itemPage.geometryDetails.boundingBoxTooltipContent', { ns: 'rails', lng: locale })
  const thinWallsTooltipContent =
    i18n.t('itemPage.geometryDetails.thinWallsTooltipContent', { ns: 'rails', lng: locale })

  return (
    <div className="cgt-verification-details__geometry-table">
    {geometryDetails.volume && (
      <GeometryItem
        title="Volume"
        value={`${volume} ${volumeUnit}`}
        tooltipContent={volumeTooltipContent}
        />
    )}
    {geometryDetails.boundingBoxX && geometryDetails.boundingBoxY && geometryDetails.boundingBoxZ && (
      <GeometryItem
        title="Bounding Box"
        value={`${geometryDetails.boundingBoxX} × ${geometryDetails.boundingBoxY} × ${
          geometryDetails.boundingBoxZ
        } mm`}
        tooltipContent={boundingBoxTooltipContent}
      />
    )}
    {geometryDetails.tooThinWallsCount !== undefined && geometryDetails.minimalAllowedThickness && (
      <GeometryItem
        title="Thin Walls"
        value={`${geometryDetails.tooThinWallsCount} areas below ${
          geometryDetails.minimalAllowedThickness
        } mm`}
        tooltipContent={thinWallsTooltipContent}
      />
    )}
  </div>
  )
}

GeometryDetailsSection.propTypes = {
  geometryDetails: shape({
    volume: number,
    boundingBoxX: number,
    boundingBoxY: number,
    boundingBoxZ: number,
    tooThinWallsCount: number,
    minimalAllowedThickness: number,
  }).isRequired,
  locale: string,
}


export default GeometryDetailsSection
